import { CommonInput, CommonModal } from 'components'
import React, { useState } from 'react'
import '../../assets/css/modal.css'
import toast from 'react-hot-toast';
import { addMaterialType } from 'features';
// import { uploadBannerFiles } from '_services';

const AddMaterialModal = (props) => {

    let { closeModal, getMaterial } = props
    const [loading, setLoading] = useState(false)
    const [formValue, setFormValue] = useState({
        name: ''
    })

    const propsAddBanner = {
        ...props,
        isLoadding: loading,
        onSubmit: (e) => onSubmitFunction(e),
        // disabled: loading,
    }


    const handleTextChange = async (e) => {
        const textname = e?.target?.name;
        const text = e?.target?.value;
    
        if (text) {
            setFormValue((s) => ({ ...s, [textname]: text }));
        } else {
            toast.error("Text input cannot be empty.");
        }
    };

    const onSubmitFunction = async () => {
        setLoading(false);
        try {
            const res = await addMaterialType(formValue);
            if (res?.responseCode === 200) {
                closeModal(false);
                setLoading(false);
                getMaterial()
            }
        } catch (error) {
            setLoading(false);
        }
    }
  return (
    <>
            <CommonModal {...propsAddBanner}>
                <div className="_endTr_body">
                    <div className='singleDiv _fileType'>
                        <CommonInput
                            type="text"
                            label="Add Material"
                            name='name'
                            value={formValue?.name}
                            onChange={(e) => handleTextChange(e)}
                        />
                    </div>
                </div>
            </CommonModal>
        </>
  )
}

export default AddMaterialModal